export class Constants {
  public static readonly ZERO: number = 0;
  public static readonly DEFAULT_VIEW_WIDTH: number = 400;
  public static readonly DEFAULT_VIEW_HEIGHT: number = 800;
  public static readonly MAX_WIDTH_VIEW = 400;

}
